module.exports = "pegasus_template/assets/blocks/tile-layout-15.png";